module.exports = __webpack_public_path__ + "static/media/sample places comparison - comapre places.1dae2e26.png";